import { ConfigEntry } from '../services/config.service';
import { HOLIDAY_CARE_CONFIG, HOLIDAY_CARE_GROUP_NAME, HOLIDAY_CARE_GROUP_DESCRIPTION } from './holiday-care.config';
import { SCHOOLYEAR_CONFIG, SCHOOLYEAR_GROUP_NAME, SCHOOLYEAR_GROUP_DESCRIPTION } from './schoolyear.config';
import { ALTERATIONS_CONFIG } from './alterations.config';

/**
 * All configuration entries from all groups
 */
export const ALL_CONFIG_ENTRIES: ConfigEntry[] = [
  ...HOLIDAY_CARE_CONFIG,
  ...SCHOOLYEAR_CONFIG,
  ...ALTERATIONS_CONFIG,
  // Add other group configs here when created
];

/**
 * Group display names
 */
export const GROUP_NAMES: Record<string, string> = {
  'holiday_care': HOLIDAY_CARE_GROUP_NAME,
  'schoolyear': SCHOOLYEAR_GROUP_NAME,
  'alterations': 'Vertragsänderungen',
  'general': 'Allgemein',
  'notifications': 'Benachrichtigungen',
  'payments': 'Zahlungen',
};

/**
 * Group descriptions
 */
export const GROUP_DESCRIPTIONS: Record<string, string> = {
  'holiday_care': HOLIDAY_CARE_GROUP_DESCRIPTION,
  'schoolyear': SCHOOLYEAR_GROUP_DESCRIPTION,
  'alterations': 'Einstellungen für Modulwechsel, Vertragsänderungen und Kündigungen',
  'general': 'Allgemeine Anwendungseinstellungen',
  'notifications': 'E-Mail- und Benachrichtigungseinstellungen',
  'payments': 'Zahlungsverarbeitungseinstellungen',
};

/**
 * Export individual group configs for direct access
 */
export { HOLIDAY_CARE_CONFIG } from './holiday-care.config';
export { SCHOOLYEAR_CONFIG } from './schoolyear.config';
export { ALTERATIONS_CONFIG } from './alterations.config';